// ハンバーガーメニュー連動ヘッダー固定システム
class HamburgerHeaderControl {
  constructor() {
    this.hamburgerButton = null;
    this.announcementBar = null;
    this.headerSection = null;
    this.mobileMenuDrawer = null;

    this.init();
  }

  init() {
    // 1200px以上の画面幅でのみ機能
    if (window.innerWidth < 1200) {
      return;
    }

    // 要素を取得
    this.hamburgerButton = document.querySelector(
      ".c-header__icon-wrapper__hamburger"
    );
    this.announcementBar = document.querySelector(
      ".shopify-section--announcement-bar"
    );
    this.headerSection = document.querySelector(".shopify-section--header");
    this.mobileMenuDrawer = document.querySelector("#mobile-menu-drawer");

    if (!this.hamburgerButton) {
      return;
    }

    this.bindEvents();
    this.startPositionTracking();
  }

  bindEvents() {
    // ハンバーガーボタンのクリックイベント
    this.hamburgerButton.addEventListener("click", () => {
      this.handleHamburgerClick();
    });

    // aria-expandedの変化を監視（toggle-buttonの状態変化）
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "aria-expanded") {
          this.handleMenuStateChange();
        }
      });
    });

    observer.observe(this.hamburgerButton, {
      attributes: true,
      attributeFilter: ["aria-expanded"],
    });

    // リサイズイベントを監視（画面幅の変化に対応）
    window.addEventListener("resize", () => {
      if (window.innerWidth < 1200) {
        this.removeFixedClasses();
      }
    });
  }

  handleHamburgerClick() {
    // 1200px以上の画面幅でのみ動作
    if (window.innerWidth < 1200) {
      return;
    }

    // クリック時に即座にis-fixedを付与
    this.addFixedClasses();

    // 少し遅延してメニューの状態をチェック
    setTimeout(() => {
      this.handleMenuStateChange();
    }, 100);
  }

  handleMenuStateChange() {
    // 1200px以上の画面幅でのみ動作
    if (window.innerWidth < 1200) {
      return;
    }

    const isExpanded =
      this.hamburgerButton.getAttribute("aria-expanded") === "true";

    if (isExpanded) {
      // メニューオープン時：is-fixedクラスを追加
      this.addFixedClasses();
    } else {
      // メニュークローズ時：必要に応じてis-fixedクラスを削除
      this.handleMenuClose();
    }
  }

  addFixedClasses() {
    // アナウンスバーにis-fixedを追加（既に存在しない場合）
    if (
      this.announcementBar &&
      !this.announcementBar.classList.contains("is-fixed")
    ) {
      this.announcementBar.classList.add("is-fixed");
    }

    // ヘッダーセクションにis-fixed・is-fixed-customを追加（既に存在しない場合）
    if (this.headerSection) {
      if (!this.headerSection.classList.contains("is-fixed")) {
        this.headerSection.classList.add("is-fixed");
      }
      if (!this.headerSection.classList.contains("is-fixed-custom")) {
        this.headerSection.classList.add("is-fixed-custom");
      }
    }
  }

  handleMenuClose() {
    // メニュークローズ時の処理
    const headerHeight = this.getHeaderHeightFromCSS();
    const scrollY = window.scrollY;

    if (scrollY <= headerHeight) {
      // --header-heightの高さ以下の場合：is-fixed・is-fixed-customを必ずつける
      this.addFixedClasses();
      this.removeFixedClasses();
    } else {
      // --header-heightの高さより大きい場合：is-fixed・is-fixed-customを削除
      this.headerSection.classList.remove("is-fixed-custom");
    }
  }

  getHeaderHeightFromCSS() {
    // CSS変数--header-heightの値を取得
    const headerHeightValue = getComputedStyle(document.documentElement)
      .getPropertyValue("--header-height")
      .trim();

    // pxを除去して数値に変換
    const headerHeight = parseFloat(headerHeightValue.replace("px", "")) || 0;

    return headerHeight;
  }

  removeFixedClasses() {
    if (
      this.announcementBar &&
      this.announcementBar.classList.contains("is-fixed")
    ) {
      this.announcementBar.classList.remove("is-fixed");
    }

    if (this.headerSection) {
      if (this.headerSection.classList.contains("is-fixed")) {
        this.headerSection.classList.remove("is-fixed");
      }
      if (this.headerSection.classList.contains("is-fixed-custom")) {
        this.headerSection.classList.remove("is-fixed-custom");
      }
    }
  }

  getHeaderBottomPosition() {
    let totalHeight = 0;

    // アナウンスバーの高さを加算
    if (this.announcementBar) {
      const announcementRect = this.announcementBar.getBoundingClientRect();
      const announcementStyle = window.getComputedStyle(this.announcementBar);

      if (announcementStyle.display !== "none" && announcementRect.height > 0) {
        totalHeight += announcementRect.height;
      }
    }

    // ヘッダーの高さを加算
    if (this.headerSection) {
      const headerRect = this.headerSection.getBoundingClientRect();
      totalHeight += headerRect.height;
    }

    return totalHeight;
  }

  startPositionTracking() {
    // ヘッダー位置の継続的な追跡
    const updatePosition = () => {
      // 1200px以上の画面幅でのみ動作
      if (window.innerWidth < 1200) {
        requestAnimationFrame(updatePosition);
        return;
      }

      const headerBottom = this.getHeaderBottomPosition();

      // CSS変数として設定
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${headerBottom}px`
      );

      requestAnimationFrame(updatePosition);
    };

    updatePosition();
  }
}

// より軽量な実装版
class SimpleHamburgerFix {
  constructor() {
    this.hamburger = document.querySelector(
      ".c-header__icon-wrapper__hamburger"
    );
    this.announcement = document.querySelector(
      ".shopify-section--announcement-bar"
    );
    this.header = document.querySelector(".shopify-section--header");

    if (this.hamburger) {
      this.hamburger.addEventListener("click", () => {
        // is-fixedクラスを安全に追加
        if (
          this.announcement &&
          !this.announcement.classList.contains("is-fixed")
        ) {
          this.announcement.classList.add("is-fixed");
        }
        if (this.header) {
          if (!this.header.classList.contains("is-fixed")) {
            this.header.classList.add("is-fixed");
          }
          if (!this.header.classList.contains("is-fixed-custom")) {
            this.header.classList.add("is-fixed-custom");
          }
        }
      });
    }
  }
}

// 手動実行用の関数
function addFixedToHeaderSections() {
  const announcement = document.querySelector(
    ".shopify-section--announcement-bar"
  );
  const header = document.querySelector(".shopify-section--header");

  if (announcement && !announcement.classList.contains("is-fixed")) {
    announcement.classList.add("is-fixed");
  }

  if (header) {
    if (!header.classList.contains("is-fixed")) {
      header.classList.add("is-fixed");
    }
    if (!header.classList.contains("is-fixed-custom")) {
      header.classList.add("is-fixed-custom");
    }
  }
}

// 手動削除用の関数
function removeFixedFromHeaderSections() {
  const announcement = document.querySelector(
    ".shopify-section--announcement-bar"
  );
  const header = document.querySelector(".shopify-section--header");

  if (announcement && announcement.classList.contains("is-fixed")) {
    announcement.classList.remove("is-fixed");
  }

  if (header) {
    if (header.classList.contains("is-fixed")) {
      header.classList.remove("is-fixed");
    }
    if (header.classList.contains("is-fixed-custom")) {
      header.classList.remove("is-fixed-custom");
    }
  }
}

// 初期化
document.addEventListener("DOMContentLoaded", () => {
  // フル機能版を使用
  window.hamburgerControl = new HamburgerHeaderControl();

  // または軽量版を使用
  // window.hamburgerControl = new SimpleHamburgerFix();
});

// デバッグ用：コンソールで手動実行
window.addFixedToHeaders = addFixedToHeaderSections;
window.removeFixedFromHeaders = removeFixedFromHeaderSections;
